import { OptionDto } from "@/dtos";
import { ChipStatus } from "@/helpers/types";

const status = [
    { value: parseInt(ChipStatus.FREE), label: 'Libre' },
    { value: parseInt(ChipStatus.OCCUPIED), label: 'Ocupado' },
    { value: parseInt(ChipStatus.DISABLED), label: 'Desactivado' }
] as OptionDto[];

export const getChipStatusOptions = (): OptionDto[] => {
    return status;
}

export const getChipStatusOption = (value: number): OptionDto => {
    return status.find((x) => x.value == value) ?? status[0];
}

export const getChipStatus = (value: number): ChipStatus => {
    switch (value) {
        case 1001:
            return ChipStatus.FREE;
        case 1002:
            return ChipStatus.OCCUPIED;
        case 1003:
            return ChipStatus.DISABLED;
        default:
            return ChipStatus.FREE;
    }
}